<template>
  <div class="persenPage" v-if="showHide">
    <el-dialog
      :close-on-click-modal="false"
      title="选择部门"
      :visible.sync="showHide"
      @close="cancel"
      append-to-body
      width="780px"
      class="add-dialog"
    >
      <div class="centerPage">
        <div class="left_page">
          <div class="left_block">
            <div class="input_top">
              <div class="but_border">
                <el-input
                  class="input_"
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                >
                </el-input>
              </div>

              <div class="tree_user">
                <el-tree
                  :props="props"
                  :data="treeData"
                  accordion
                  node-key="id"
                  :filter-node-method="filterNode"
                  default-expand-all
                  @node-click="handleNodeClick"
                  show-checkbox
                  @check-change="handleCheckChange"
                  @check="oncheckuser"
                  ref="tree"
                >
                  <template
                    class="el-tree-node__label"
                    slot-scope="{ node, data }"
                  >
                    <div class="tree__item">
                      {{ data.title }}
                    </div>
                  </template>
                </el-tree>
              </div>
            </div>
          </div>
          <div class="right_block">
            <div class="input_top">
              <div class="top_right_block">
                <div>
                  已选 {{ checkdepartment.length }}/{{ isOnly ? 1 : usertotal }}
                </div>
                <el-button @click="center" type="text" size="small">
                  清空
                </el-button>
              </div>
              <div class="checkdepartment">
                <div
                  :class="['onUser', checkuserBclick == index ? 'checks' : '']"
                  v-for="(item, index) in checkdepartment"
                  :key="index"
                  @click="checkuserBlockclick(index)"
                  :data-index="index"
                >
                  <div>{{ item.title || item.fullName}}</div>
                  <div>
                    <i
                      @click="iconeclick(item.id, index)"
                      class="el-icon-circle-close chicon"
                      v-if="checkuserBclick == index"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="but_que_cancel">
                <el-button @click="cancel"> 取消</el-button>
                <el-button type="primary" class="cherk_but" @click="checkreturn"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/text/department";
import * as validate from "@/util/validate";
export default {
  name: "persenUserdeperment",
  data() {
    return {
      defaultShowNodes: [],
      showHide: false,
      filterText: "",
      treeData: [],
      checkdepartment: [],
      checkuserBclick: 0,
      usertotal: 0,
      props: {
        label: "title",
        children: "children",
      },
      checked:false
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  props: {
    checkdepartment: {
      type: Array,
      default: () => [],
    },
    isOnly: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.departmentPage();

    // this.department("", "content");
  },
  // watch: {
    // treeData:{
    //     deep: true,
    //   handler() {
    //     this.getPageId();
    //   },
    // }
  // },
  methods: {
    departmentPage() {
      api.department().then((res) => {
        // console.log(res.data.data);
        this.treeData = res.data.data;
        this.usertotal = res.data.data[0].children.length;
      });
    },
    showmode(data) {
      this.showHide = true;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(data);
        this.checkdepartment = this.$refs.tree.getCheckedNodes();
        // console.log(this.checkdepartment);
      });
    },

    ///data=[]
    showModel() {
      this.showHide = true;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(this.checkdepartment);
      });
    },

    handleNodeClick(data) {
      if (data.hasChildren == false) {
        // console.log(data.hasChildren + "----" + data.id);
      }
    },
    handleCheckChange(data, checked, indeterminate) {
       this.checked=checked
       
    },
    oncheckuser(data, checkedKeys) {
      
      if (!validate.validatenull(data.children)) {
        if (this.isOnly) {
          this.$message({
            type: "error",
            message: "只能选择一个单位,或展开选择",
          });
          this.$refs.tree.setCheckedKeys([]);
          return;
        } else {
           this.childrenLoop(data)
          // data.children.map((item) => {
          //   this.checksuser(item);
          // });
        }
      } else {
        this.checksuser(data, checkedKeys.checkedKeys);
      }
    },
    childrenLoop(data){
       if(!validate.validatenull(data.children)){
         data.children.map((item) => {
           this.childrenLoop(item);
         })
       }else {
         this.checksuser(data)
       }
    },
    checksuser(data, checkedKeys = []) {
      if (this.isOnly) {
        if (checkedKeys.length > 0) {
          this.$refs.tree.setCheckedNodes([data]);
          this.checkdepartment = [data];
        } else {
          this.$refs.tree.setCheckedNodes([]);
          this.checkdepartment = [];
        }
      } else {
        let index = this.checkdepartment.findIndex((val) => val.id == data.id);
        if (index == -1) {
          // if (!validate.validatenull(data.children)){
          //     this.oncheckuser(data)
          // }else {
          //    this.checkUserList = [...this.checkUserList, data];
          // }
          this.checkdepartment = [...this.checkdepartment, data];
        } else {
           if(!this.checked){
              this.$delete(this.checkdepartment, index);
           }
        }
      }
    },
    checkuserBlockclick(index) {
      this.checkuserBclick = index;
    },
    iconeclick(id, index) {
      this.$delete(this.checkdepartment, index);
      this.$refs.tree.setChecked(id, false);
      // setChecked
      // console.log(index);
    },
    // departmentPage() {
    //   api
    //     .departmentuseruser({})
    //     .then((res) => {
    //       this.treeData = res.data.data.data;
    //       res.data.data.data.forEach((ites) => {
    //         this.defaultShowNodes.push(ites.id);
    //       });
    //       // this.defaultShowNodes.push(res.data.data.data[0].id);
    //       //
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },

    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    center() {
      this.checkdepartment = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    checkreturn() {
      this.filterText = "";
      this.$emit("setDepartment", this.checkdepartment);
      this.showHide = false;
    },
    cancel() { 
      this.filterText = "";
      this.showHide = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.persenPage {
  // position: absolute;
  // z-index: 10;
  // top: 0;
  // display: flex;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 0;
  // overflow: auto;
  // margin: 0;
  // // position: absolute;
  // // z-index: 2130;
  // // left: 0;
  // // right: 0;
  // // top: 0;
  // // display: flex;
  // justify-content: center;
  // align-items: center;
  // bottom: 0;
  // background: rgba(0, 0, 0, 0.5);
}
.dialoging {
  width: 100%;
}
.centerPage {
  width: 750px;
  height: 520px;
  background: #fff;
  .showpageHead {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ddd;
    box-shadow: 0px 2px 6px 0px #ddd;
    padding: 8px 20px;
    .leftTitle {
      font-size: 18px;
      font-weight: bold;
    }
    .iconclose {
      font-size: 20px;
      cursor: pointer;
    }
    .leftTitle {
      width: 95%;
    }
  }
  .left_page {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;

    height: 100%;
    .left_block {
      flex: 1;
      padding-top: 20px;
      text-align: center;
      .input_ {
        width: 80%;
        // border-radius: 30px;
      }
      .but_border {
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      .tree_user {
        padding-left: 20px;
        height: 385px;
        overflow-y: scroll;
        margin-top: 20px;
        .tree__item {
          text-align: left;
        }
      }
    }
    .right_block {
      flex: 1;
      // height: 400px;
      // overflow-y: scroll;
      padding-top: 20px;
      border-left: 1px solid #ddd;
      .top_right_block {
        font-weight: bold;
        text-indent: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
      }
      .checkdepartment {
        display: flex;
        flex-direction: column;
        line-height: 40px;
        height: 400px;
        overflow-y: scroll;
        padding-left: 15px;
        padding-bottom: 20px;
        .onUser {
          display: flex;
          padding: 0 20px;
          flex-direction: row;
          cursor: pointer;
          justify-content: space-between;
        }
        .checks {
          background: rgba(255, 2, 2, 0.1);
          border: 0.5px solid rgba(255, 2, 2, 0.3);
        }
        .chicon {
          font-weight: bold;
        }
      }
      .but_que_cancel {
        display: flex;
        justify-content: flex-end;
        float: right;

        .el-button {
        }
      }
    }
  }
}
.add-dialog /deep/.el-dialog__body {
  padding: 0;
}
.add-dialog /deep/.el-dialog__header {
  border-bottom: 1px solid #e2e2e2;
  padding: 20px;
}
.add-dialog {
  /deep/ .el-checkbox {
    display: none;
  }

  /deep/ .el-tree-node__children {
    .el-checkbox {
      display: block;
    }
  }
}
// /deep/.el-tree-node__content /deep/label /deep/.el-checkbox {
//     display: none
// }
</style>
<style >
</style>